interface StatusItem {
    num: number;
    name: string;
};

// 운송장 상태
export const deliveryStatusList: StatusItem[] = [
    { num: 1, name: "오더접수" },
    { num: 2, name: "픽업예약" },
    { num: 3, name: "픽업완료" },
    { num: 4, name: "배송중" },
    { num: 5, name: "배송완료" },
    { num: 6, name: "접수취소" }
];

// 담당기사 담당업무
export const driverTaskList: StatusItem[] = [
    { num: 3, name: "픽업담당" },
    { num: 4, name: "배송담당" }
];